<div class="fs-section-block fs-margin-0 header-background ">
  <div class="d-flex justify-content-between align-items-center">
    <div [ngClass]="currentClass" [ngStyle]="getHeadingStyle()">
      <span class="mat-headline">{{Heading}}</span>
      <p *ngIf="helpText" class="fs-hint-text">{{helpText}}</p>
    </div>
    <div class="d-flex align-items-center" style="gap: 10px;">
      <button *ngIf="showCreateReplenishmentBtn" style="height: fit-content;"
        (click)="regenerate()" class="mat-button mat-primary mat-raised-button" [disabled]="isButtonDisabled"> Create
        Replenishment
      </button>
      <app-upload-molecule *ngIf="showTemplateBtn" [templateData]="templateData"></app-upload-molecule>
      <button *ngIf="showPrintReplenishmentBtn" style="height: fit-content;"
        (click)="printClicked.emit()" class="mat-button mat-primary mat-raised-button"> Print Replenishment Slip
      </button>
      <button *ngIf="showFilterButton" style="height: fit-content;" (click)="showFilters()"
        class="mat-button mat-primary mat-raised-button">
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="filter_alt"></mat-icon>
        Filters
      </button>
    </div>
  </div>
</div>